import { render, staticRenderFns } from "./TileButton.vue?vue&type=template&id=60e5f34c&scoped=true&"
import script from "./TileButton.vue?vue&type=script&lang=js&"
export * from "./TileButton.vue?vue&type=script&lang=js&"
import style0 from "./TileButton.vue?vue&type=style&index=0&id=60e5f34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e5f34c",
  null
  
)

export default component.exports